import Vue from './app';
import store from './store'
import i18n from "./i18n";

new Vue({
  store,
  i18n,
  el: '#app',
});
